import http from '@/api/request'
import { useUserStore } from '@/stores/user'

/**
 * 班级信息搜索
 * @param data
 * @returns {*}
 */
export function gradeSearch (data) {
  return http().post('/resource/api/classroom/search', data)
}

/**
 * 分类-班级条件查询
 * @param data
 * @returns {*}
 */
export function getGradeList (data) {
  return http().post('/resource/api/classroom/page', data)
}

/**
 * 班级详情
 * @param data
 * @returns {*}
 */

export function gradeView (id) {
  const { getToken } = useUserStore()
  const token = getToken()
  if (token) {
    return http().get(`/resource/auth/classroom/view?id=${id}`)
  }
  return http().get(`/resource/api/classroom/view?id=${id}`)
}

export function gradeCourseView (data) {
  const { getToken } = useUserStore()
  const token = getToken()
  if (token) {
    return http().post('/resource/auth/classroom/course/page', data)
  }
  return http().post('/resource/api/classroom/course/page', data)
}

export function gradeExamView (data) {
  const { getToken } = useUserStore()
  const token = getToken()
  if (token) {
    return http().post('/resource/auth/classroom/exam/page', data)
  }
  return http().post('/resource/api/classroom/exam/page', data)
}

export function gradeNoticeView (data) {
  const { getToken } = useUserStore()
  const token = getToken()
  if (token) {
    return http().post('/resource/auth/classroom/notice/page', data)
  }
  return http().post('/resource/api/classroom/notice/page', data)
}

export function gradeNoticeDetail (id) {
  const { getToken } = useUserStore()
  const token = getToken()
  if (token) {
    return http().get('/resource/auth/classroom/notice/view?id=' + id)
  }
  return http().get('/resource/api/classroom/notice/view?id=' + id)
}

export function gradeCommentView (data) {
  return http().post('/resource/api/goods/comment/page', data)
}

/**
 * 评论添加
 * @param data
 * @returns {*}
 */
export function gradeCommentSave (data) {
  return http().post('/resource/auth/goods/comment/save', data)
}

/**
 * 评论回复
 * @param data
 * @returns {*}
 */
export function gradeCommentReplySave (data) {
  return http().post('/resource/auth/goods/comment/reply/save', data)
}

export function gradeJoin (data) {
  return http().put('/resource/auth/classroom/student/join', data)
}

export function gradeHomeworkPage (data) {
  const { getToken } = useUserStore()
  const token = getToken()
  if (token) {
    return http().post('/resource/auth/classroom/task/page', data)
  }
  return http().post('/resource/api/classroom/task/page', data)
}

export function gradeHomeworkDetail (id) {
  return http().get('/resource/auth/classroom/task/view?id=' + id)
}

export function gradeHomeworkSave (data) {
  return http().put('/resource/auth/classroom/task/general/submit', data)
}

export function gradeHomeworkStart (id) {
  return http().get('/resource/auth/classroom/task/start?id=' + id)
}

export function gradeHomeworkAnswerSave (data) {
  return http().post('/resource/auth/classroom/task/save/question/answer', data)
}

export function gradePracticeHomeworkSave (data) {
  return http().put('/resource/auth/classroom/task/practice/submit', data)
}

export function gradeCertApply (data) {
  return http().post('/resource/auth/classroom/student/cert/apply', data)
}

// 附件下载
export function taskAttachDownLoad (data) {
  return http().post('/resource/auth/classroom/task/attach/download', data)
}

// 附件预览
export function taskAttachPreview (data) {
  return http().post('/resource/auth/classroom/task/attach/preview', data)
}
